export interface VirtualOperatorConfigInterface {
    id: string;
    descr: string;
    avatar?: string;
    newAvatar: boolean;
}

export function getSelectedVirtualOperator(operators: VirtualOperatorConfigInterface[], id?: string) {
    if (!id) {
        return operators[0];
    } else {
        return operators.find(item => item.id === id);
    }
}